/**
 * A QR symbol drawn from the module matrix the API returns (1B-4a).
 *
 * One `<rect>` per dark module inside one `<svg>`. Not an image route, because
 * a URL that renders a QR is a URL that carries the shared secret; not an npm
 * encoder, because the client's three runtime dependencies are worth keeping;
 * and not `dangerouslySetInnerHTML`, of which this app has exactly one and it
 * is `Markdown.jsx`.
 *
 * Black on white, hard-coded, and deliberately not a design token: a scanner
 * needs dark modules on a light field with real contrast, so this must look
 * the same in both themes. The white `<rect>` is the quiet zone as much as the
 * background — a symbol drawn edge to edge on a dark page does not scan.
 */
export default function QrCode({ rows, label = 'Scan this with your authenticator app' }) {
  const side = rows.length
  const quiet = 2
  const span = side + quiet * 2
  return (
    <svg
      className="qr-code"
      viewBox={`0 0 ${span} ${span}`}
      width="192"
      height="192"
      role="img"
      aria-label={label}
      shapeRendering="crispEdges"
    >
      <rect x="0" y="0" width={span} height={span} fill="#ffffff" />
      {rows.map((row, y) =>
        [...row].map((module, x) =>
          module === '1' ? (
            <rect
              key={`${x}-${y}`}
              x={x + quiet}
              y={y + quiet}
              width="1"
              height="1"
              fill="#000000"
            />
          ) : null,
        ),
      )}
    </svg>
  )
}
